import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Field } from "@/components/common/Page";
import { api, errMsg } from "@/lib/api";

const OPTIONS = [
  { value: "presente", label: "Presente" },
  { value: "ausente", label: "Ausente" },
  { value: "cancelada", label: "Aula cancelada" },
  { value: "reagendada", label: "Aula reagendada" },
];

export const AttendanceDialog = ({ lesson, open, onOpenChange, onSaved }) => {
  const [form, setForm] = useState({ status: "presente", notes: "", new_date: "", new_start_time: "" });
  const [error, setError] = useState("");

  useEffect(() => {
    if (open && lesson) {
      setForm({ status: lesson.attendance?.status || "presente", notes: lesson.attendance?.notes || "", new_date: lesson.date, new_start_time: lesson.start_time });
      setError("");
    }
  }, [open, lesson]);

  const submit = async (e) => {
    e.preventDefault();
    const payload = { status: form.status, notes: form.notes || null };
    if (form.status === "reagendada") Object.assign(payload, { new_date: form.new_date, new_start_time: form.new_start_time });
    try {
      await api.post(`/classes/${lesson.id}/attendance`, payload);
      toast.success("Presença registrada");
      onSaved?.();
      onOpenChange(false);
    } catch (err) {
      setError(errMsg(err));
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="attendance-dialog">
        <DialogHeader><DialogTitle>Registrar presença</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="grid grid-cols-2 gap-2">
            {OPTIONS.map((o) => (
              <button type="button" key={o.value} onClick={() => setForm((f) => ({ ...f, status: o.value }))}
                className={`rounded-lg border px-3 py-3 text-sm font-medium transition-colors ${form.status === o.value ? "border-primary bg-primary/10 text-primary" : "hover:bg-muted"}`}
                data-testid={`attendance-option-${o.value}`}>
                {o.label}
              </button>
            ))}
          </div>
          {form.status === "reagendada" && (
            <div className="grid grid-cols-2 gap-3">
              <Field label="Nova data"><Input type="date" value={form.new_date} onChange={(e) => setForm((f) => ({ ...f, new_date: e.target.value }))} required data-testid="attendance-new-date-input" /></Field>
              <Field label="Novo horário"><Input type="time" value={form.new_start_time} onChange={(e) => setForm((f) => ({ ...f, new_start_time: e.target.value }))} required data-testid="attendance-new-time-input" /></Field>
            </div>
          )}
          <Field label="Observações">
            <Textarea rows={3} placeholder="Ex.: Aluno apresentou dificuldade em equações de segundo grau." value={form.notes}
              onChange={(e) => setForm((f) => ({ ...f, notes: e.target.value }))} data-testid="attendance-notes-input" />
          </Field>
          {error && <p className="text-sm text-destructive" data-testid="attendance-error">{error}</p>}
          <DialogFooter><Button type="submit" data-testid="attendance-submit-btn">Salvar presença</Button></DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
